import { useRef, useEffect, RefObject, CSSProperties } from "react";

interface UseHoneypotReturn {
  isBot: boolean;
  honeypotProps: {
    ref: RefObject<HTMLInputElement>;
    type: "text";
    name: string;
    tabIndex: -1;
    autoComplete: "off";
    style: CSSProperties;
  };
}

/**
 * Hook to detect bot activity using a honeypot field
 * Returns a ref and props for a hidden input field that should be added to forms
 * If the field is filled out, it's likely a bot
 */
export const useHoneypot = (fieldName: string = "website"): UseHoneypotReturn => {
  const honeypotRef = useRef<HTMLInputElement>(null);
  const isBotRef = useRef(false);

  useEffect(() => {
    const checkHoneypot = () => {
      if (honeypotRef.current?.value) {
        isBotRef.current = true;
        console.warn("[Honeypot] Bot detected - honeypot field was filled");
      }
    };

    // Check periodically
    const interval = setInterval(checkHoneypot, 500);

    return () => clearInterval(interval);
  }, []);

  return {
    isBot: isBotRef.current,
    honeypotProps: {
      ref: honeypotRef,
      type: "text",
      name: fieldName,
      tabIndex: -1,
      autoComplete: "off",
      style: {
        position: "absolute",
        left: "-9999px",
        width: "1px",
        height: "1px",
        opacity: 0,
        pointerEvents: "none",
      },
    },
  };
};
